import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { RayFormValidation, RayForm } from '../../components/common';
import { FileItem, FileUpload } from '../../components/common/FileUpload';
import { ProductAction } from '../../actions';
import { Translate as t } from '../../config/Translate';
import { UserType } from '../../config';
import { ORG_HQ } from '../../config/appConstants';

const ProductExtendedWarrantyAdd = ({ product, showModal, editItem, codeList, callbackClose, AddExtendedWarranty, UpdateExtendedWarranty }) => {
    const [info, setInfo] = useState({});
    const [errors, setErrors] = useState([]);

    // FEAT-047: 편집 모드 — editItem 이 있으면 그 값으로 prefill, 없으면(신규/닫힘) 기본값으로 리셋.
    // editItem 이 x→null 로 바뀔 때도 반드시 리셋해야 직전 편집값이 신규 Add 모달에 잔류하지 않는다(state leak 방지).
    useEffect(() => {
        setErrors([]);
        if (editItem) {
            setInfo({
                // Sentry RAYGUARDV2-FRONT-END-29 재발 방지: dest 는 멀티셀렉트(InputSelect2) 값 →
                // 비배열(레거시 단일값 등)이 들어가면 "includes is not a function" 크래시. 배열로 정규화.
                dest: Array.isArray(editItem.dest) ? editItem.dest : [],
                amount: editItem.amount,
                amountType: editItem.amountType,
                reason: editItem.reason,
                type: editItem.type,
                creator: editItem.creator,
                attachment: editItem.attachment,
            });
            return;
        }

        const u = JSON.parse(localStorage.getItem('user'));
        const creator = u?.adminid;
        const userType = UserType(u?.companyId, u?.companyInfo?.org);
        setInfo({ type: userType === ORG_HQ ? ORG_HQ : 'BRANCH', creator });
    }, [editItem]);

    const updateVal = (e) => {
        const { name, value } = e.target;
        setInfo({ ...info, [name]: value })
    }

    const getName = (val) => {
        const n = codeList.filter(x => x.code == val);
        return n.length > 0 ? n[0].name : val;
    }

    const controls = [{
        title: '', items: [
            {
                type: 'select2',
                name: 'dest',
                label: t('product.label.productAndPart'),
                val: info && info.dest,
                isEditable: true,
                list: (product?.waranties || []).filter(x => x.category == 'wartype_ms').map(x => { return { code: x.dest, title: getName(x.dest) } }),
                isMulti: true,
                required: true
            },
            { type: 'number', name: 'amount', label: t('common.field.period'), val: info && info.amount, isEditable: true, required: true },
            {
                type: 'select2', name: 'amountType', label: t('common.field.periodUnit'), val: info && info.amountType, isEditable: true, list: [
                    { code: "d", title: t('common.label.day') },
                    { code: "M", title: t('common.label.month') },
                    { code: "y", title: t('common.label.year') }
                ], required: true
            },
            { type: 'textarea', name: 'reason', label: t('common.field.reason'), val: info && info.reason, isEditable: true, required: true },
        ]
    }];

    const handleSubmit = () => {
        const errValidate = RayFormValidation(controls, info);

        if (errValidate.length > 0) {
            setErrors(errValidate);
        } else {
            if (editItem) {
                UpdateExtendedWarranty(product.sn, editItem._id, info);
            } else {
                AddExtendedWarranty(product.sn, info);
            }
            callbackClose();
        }
    }

    return (
        <Modal show={showModal} size="lg">
            <Modal.Header>
                <h2 className="modal-title">{t('warranty.label.extendedWarranty')} {editItem ? `(${t('common.button.edit')})` : ''}</h2>
            </Modal.Header>
            <Modal.Body className="p-0">
                <RayForm
                    handleChangeData={updateVal}
                    controls={controls}
                    errors={errors}
                    nocard={true} />

                {/* FEAT-047: 첨부 변경은 편집(edit) 스코프 밖 — BE updateExtendedWarranty 가 attachment 를 저장하지 않으므로,
                    edit 모드에서 업로드 위젯을 숨겨 무음 드롭(§7)을 방지한다. 기존 첨부는 그대로 보존된다. */}
                {!editItem &&
                <div className="input-wrapper p-2 pt-0 position-relative">
                    <label className="label pb-1">{t('common.label.attachments')}</label>
                    <FileUpload
                        option={{ doneandnew: false }}
                        extraData={{ path: "warranty/" + product.sn + "/" }}
                        callback={(e) => e ? setInfo({ ...info, attachment: { path: e.s3path, origin: e.original } }) : setInfo({ ...info, attachment: {} })} />
                </div>}
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-block btn-primary" onClick={() => handleSubmit()}>{t(editItem ? 'common.button.edit' : 'common.button.add')}</button>
                <button className="btn btn-block btn-dark" onClick={() => callbackClose()}>{t('common.button.close')}</button>
            </Modal.Footer>
        </Modal>
    );
}

const mapState = (state) => {
    const product = state.ProductReducer.product;
    return { product };
};

const mapDispatch = (dispatch) => ({
    AddExtendedWarranty: (sn, data) => dispatch(ProductAction.AddExtendedWarranty(sn, data)),
    UpdateExtendedWarranty: (sn, exId, data) => dispatch(ProductAction.UpdateExtendedWarranty(sn, exId, data))
});

export default connect(mapState, mapDispatch)(ProductExtendedWarrantyAdd);